define('view/people/user.account.and.roles.page.view',['require','exports','module','uikit/uikit','blockit','./user.account.component','./roles.list.component','./people.left.nav','fukit/fukit','backbone.radio'],function(require, exports, module) {
  // prettier-ignore
  var UIKit                = require('uikit/uikit'),
      BlocKit              = require('blockit'),
      UserAccountComponent = require('./user.account.component'),
      RolesListComponent   = require('./roles.list.component'),
      PeopleLeftNav        = require('./people.left.nav'),
      ROLES                = require('fukit/fukit').Roles,
      Radio                = require('backbone.radio');

  var RolesListPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,

        pageHeader: {
          headerText: 'My Profile',
          breadcrumbs: [
            {
              text: 'My Profile',
            },
            {
              text: '',
              route: 'profile:detail',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      model: '@resources.person',
                      formatter: function(model) {
                        var userPrincipalModel = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'userPrincipalModel'
                        );
                        var displayName = 'Current User';
                        var fullName = userPrincipalModel.get('fullName');
                        var username = userPrincipalModel.get('username');

                        displayName = model.get('fullName');
                        if (displayName.trim().length === 0) {
                          if (fullName && fullName.trim().length > 0) {
                            displayName = fullName;
                          } else if (username && username.length > 0) {
                            displayName = username;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'User Account & Roles',
            },
          ],
        },
        contentColumn: {
          components: [UserAccountComponent, RolesListComponent],
        },
        railColumn: {
          components: [
            {
              type: PeopleLeftNav,
            },
          ],
        },
      },
    },
  });

  module.exports = RolesListPageView;
});

